namespace Areas.Dialogs.CreateRequest {
    "use strict";

    export class CreateRequestDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void) {
            super("CreateRequest", closeHandler);
        }

        protected ok = (e: any) => {
            const form = $("#CreateRequestForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");
                newData.ProjectInitiationType = form.option("ProjectInitiationType");
                sendRequest("/Dialog/CreateRequest/Post", JSON.stringify(newData), "POST", () => {
                    this.close(DialogResult.Ok, null);
                });
            }
        }
    }

    export function nextHistorical() {
        showCreateForm();
        showHistoricalExplanation();
        $("#CreateRequestForm").dxForm("instance").option("ProjectInitiationType", "Historical");
        $("#CreateRequestOkDialog").dxButton("instance").option("text", "Create Historical");
    }

    export function nextNew() {
        showCreateForm();
        showNewExplanation();
        $("#CreateRequestForm").dxForm("instance").option("ProjectInitiationType", "New");
        $("#CreateRequestOkDialog").dxButton("instance").option("text", "Create New");
    }

    export function back() {
        showInformation();
        $("#CreateRequestForm").dxForm("instance").option("ProjectInitiationType", "");
        $("#CreateRequestOkDialog").dxButton("instance").option("text", "Create");
    }

    function showCreateForm() {
        $("#Information").hide("slow");
        $("#MainForm").show("slow");
    }

    function showHistoricalExplanation() {
        $("#HistoricalExplanation").show();
        $("#NewExplanation").hide();
    }

    function showNewExplanation() {
        $("#HistoricalExplanation").hide();
        $("#NewExplanation").show();        
    }

    function showInformation() {
        $("#Information").show("slow");
        $("#MainForm").hide("slow");
    }
}